import { render, staticRenderFns } from "./UpdateMovementProduct.vue?vue&type=template&id=f3c2156c&scoped=true&"
import script from "./UpdateMovementProduct.vue?vue&type=script&lang=js&"
export * from "./UpdateMovementProduct.vue?vue&type=script&lang=js&"
import style0 from "./UpdateMovementProduct.vue?vue&type=style&index=0&id=f3c2156c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c2156c",
  null
  
)

export default component.exports